import type { ReactNode } from "react";

/**
 * The light "Fresh Paper" wrapper for every parent screen.
 *
 * `data-surface="light"` flips the token set — the parent opens this from an
 * SMS link in whatever browser they have, often in daylight, with no account
 * and no dark-mode preference of ours to inherit. It is the only place in the
 * product that is not Midnight Prep.
 */
export function ParentSurface({ children }: { children: ReactNode }) {
  return (
    <div
      data-surface="light"
      className="min-h-dvh bg-bg text-text"
      style={{ colorScheme: "light" }}
    >
      <div className="mx-auto flex min-h-dvh w-full max-w-[480px] flex-col px-5 pb-8 pt-6">
        <span className="font-[family-name:var(--font-display)] text-[17px] font-bold">
          Prep<span className="text-accent">AI</span>
        </span>
        {children}
      </div>
    </div>
  );
}
